var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import * as ServiceContact from '../../services/contact';
import { EditionContact } from './EditionContact';
import { Link } from '../../utils/Link';
import { Table } from '../../utils/Table';
import { ClientIcon, CloseIcon, CommentaireIcon, ContactIcon, EmailIcon, MobileIcon, PhoneIcon, } from '../../utils/Icons';
import { Typography } from '../../utils/Typography';
import { Stack } from '@mui/material';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { IconButton } from '../../utils/IconButton';
import { getIsMobile } from '../../services/utilisateur';
export var Contact = function (props) {
    var ClientId = props.ClientId, _a = props.CanEditClient, CanEditClient = _a === void 0 ? false : _a;
    var isMobile = getIsMobile();
    var _b = useState([]), contacts = _b[0], setContacts = _b[1];
    var _c = useState(0), total = _c[0], setTotal = _c[1];
    var getData = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c, _d = _a.filtres, filtres = _d === void 0 ? null : _d, _e = _a.order, order = _e === void 0 ? null : _e;
        return __awaiter(void 0, void 0, void 0, function () {
            var _f, Contacts, Total, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ServiceContact.getContactListe(ClientId, {
                                page: page,
                                itemByPage: itemByPage,
                                filtres: filtres,
                                order: order,
                            })];
                    case 1:
                        _f = _g.sent(), Contacts = _f.Contacts, Total = _f.Total;
                        setContacts(Contacts);
                        setTotal(Total);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        setContacts([]);
                        setTotal(0);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var handleClickDelete = function (contactId, refresh) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceContact.deleteContact(contactId)];
                case 2:
                    _a.sent();
                    refresh();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(_Fragment, { children: _jsx(Table, { title: !ClientId ? 'Contacts' : '', canEdit: CanEditClient, renderModalEdition: function (handleClose, _a) {
                var _b = _a.ContactId, ContactId = _b === void 0 ? null : _b;
                return (_jsx(EditionContact, { ContactId: ContactId, ClientId: ClientId, handleClose: function () { return handleClose(); } }));
            }, refresh: getData, total: total, isResponsive: true, headers: __spreadArray(__spreadArray([
                {
                    component: function (value, _a) {
                        var handleUpdate = _a.handleUpdate, color = _a.color;
                        return (_jsx(Link, { bold: true, title: value.getLibelle, color: color, to: "/", onClick: function (e) {
                                e.preventDefault();
                                handleUpdate({ ContactId: value.IdContact });
                            }, icon: _jsx(ContactIcon, {}) }));
                    },
                }
            ], (!ClientId
                ? [
                    {
                        component: function (value) {
                            return value.client && (_jsx(Link, { title: value.client.getLibelle, color: "client", to: '/client/fiche/' + value.client.IdClient, icon: _jsx(ClientIcon, {}) }));
                        },
                    },
                ]
                : []), true), [
                {
                    assessor: 'contact_type.Libelle',
                },
                {
                    component: function (value) { return (_jsxs(Stack, __assign({ direction: isMobile ? 'column' : 'row', justifyContent: "flex-end", spacing: isMobile ? 0 : 4 }, { children: [value.Email && (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Envoyer un mail", color: "primary", href: "mailto:".concat(value.Email) }, { children: _jsx(EmailIcon, {}) })) }, { children: value.Email }))), value.Telephone && (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Contacter ce num\u00E9ro fixe", color: "primary", href: "tel:".concat(value.Telephone) }, { children: _jsx(PhoneIcon, {}) })) }, { children: value.Telephone }))), value.Mobile && (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Contacter ce num\u00E9ro mobile", color: "primary", href: "tel:".concat(value.Mobile) }, { children: _jsx(MobileIcon, {}) })) }, { children: value.Mobile }))), value.Commentaire && (_jsx(IconButton, __assign({ tooltip: value.Commentaire, color: "primary" }, { children: _jsx(CommentaireIcon, {}) })))] }))); },
                },
                {
                    align: 'right',
                    component: function (value, _a) {
                        var refresh = _a.refresh;
                        return (_jsx(_Fragment, { children: _jsx(IconButton, __assign({ tooltip: "Supprimer le contact", color: "error", onClick: function () { return handleClickDelete(value.IdContact, refresh); } }, { children: _jsx(CloseIcon, {}) })) }));
                    },
                },
            ], false), datas: contacts ? contacts : [] }) }));
};
//# sourceMappingURL=Contact.js.map